// Billing cadence toggle — swaps plan card prices between monthly and yearly.
// Targets: [data-cadence-pills] toggle buttons, [data-monthly-price] price
// elements, [data-monthly-cadence] cadence labels, [data-yearly-savings] hints.

import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

export function initCadenceToggle(root = document) {
  const toggles = root.querySelectorAll("[data-cadence-pills]");

  toggles.forEach((pills) => {
    if (!firstBind(pills)) return;

    const buttons = pills.querySelectorAll("[data-cadence]");

    // Resolve scope once at init — walk up from the toggle to find the nearest
    // ancestor that contains plan cards with price data attributes.
    let scope = pills.parentElement;
    while (scope && scope !== document.body) {
      if (scope.querySelector("[data-monthly-price]")) break;
      scope = scope.parentElement;
    }
    scope = scope || document;

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const yearly = btn.dataset.cadence === "yearly";

        // Sync any sibling form input that needs to carry the cadence
        // through a submit (the registration wizard's plan picker).
        scope.querySelectorAll("[data-cadence-input]").forEach((el) => {
          el.value = yearly ? "yearly" : "monthly";
        });

        buttons.forEach((b) => {
          const isActive =
            (yearly && b.dataset.cadence === "yearly") ||
            (!yearly && b.dataset.cadence === "monthly");
          b.classList.toggle("bg-white", isActive);
          b.classList.toggle("text-ink-900", isActive);
          b.classList.toggle("shadow-sm", isActive);
          b.classList.toggle("text-ink-500", !isActive);
          b.classList.toggle("hover:text-ink-700", !isActive);
        });

        scope.querySelectorAll("[data-monthly-price]").forEach((el) => {
          el.textContent = yearly
            ? el.dataset.yearlyPrice
            : el.dataset.monthlyPrice;
        });

        scope.querySelectorAll("[data-monthly-cadence]").forEach((el) => {
          el.textContent = yearly
            ? el.dataset.yearlyCadence
            : el.dataset.monthlyCadence;
        });

        scope.querySelectorAll("[data-yearly-savings]").forEach((el) => {
          if (yearly) {
            el.classList.remove("opacity-0", "h-0", "mb-0", "overflow-hidden");
            el.classList.add("mb-4");
          } else {
            el.classList.add("opacity-0", "h-0", "mb-0", "overflow-hidden");
            el.classList.remove("mb-4");
          }
        });

        scope.querySelectorAll("[data-monthly-spacer]").forEach((el) => {
          if (yearly) {
            el.classList.add("hidden");
          } else {
            el.classList.remove("hidden");
          }
        });
      });
    });
  });
}
